<template>
  <!-- 輸入啟動碼頁面 -->
  <div>
    <div class="py-5">
      <field-edit
        class="inputSolid"
        :field="$t('active_account_field_active_code')"
        v-model="active_code"
        :placeholder="$t('active_account_field_active_code_hint')"
        :maxlength="10"
        labelWidth="80px"
      />
    </div>
    <div class="button1" @click="submit()">
      {{ $t("common_button_commit") }}
    </div>
  </div>
</template>
<script>
import LoginApiHelper from "../../script/Utility/LoginApiHelper";
import UserInfoApiHelper from "../../script/Utility/UserInfoApiHelper";
export default {
  mounted() {
    UserInfoApiHelper.logout();
    this.$root.$on("enter", this.submit);
    if (this.$route.params.activeCode) {
      this.active_code = this.$route.params.activeCode;
      this.submit();
    }
  },
  beforeDestroy() {
    this.$root.$off("enter", this.submit);
  },
  data() {
    return {
      active_code: "",
    };
  },
  methods: {
    submit() {
      if (this.active_code) {
        loading();
        LoginApiHelper.checkActiveCode(
          this.active_code,
          this.$route.params.source
        )
          .then((result) => {
            toast(this.$t("verify_alert_token_success"));
            loading(false);
            const basicInfo = result;
            if (basicInfo.records.length > 0) {
              this.$router.push({ name: "Result", params: { basicInfo } });
            } else {
              this.$router.push({ name: "BeforeStart", params: { basicInfo } });
            }
          })
          .catch(errorHandler);
      } else {
        alert(this.$t("active_account_field_active_code_hint"));
      }
    },
  },
};
</script>